export const radSortOptions = [
  { text: "Newest", value: "newest", default: true },
  { text: "Patient Name ( a-z )", value: "patientName" },
  { text: "Patient Name ( z-a )", value: "-patientName" },
];
